'use strict';

module.exports = function() {
	if (!CK.user.$exists()) {
		const CookieManager = require('ck-core-client/source/managers/CookieManager');

		return CookieManager.mod().get('submittedEmailCapture');
	}
};
